import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import CapacityPricing from "../../../Components/Host/Dashboard/CapacityPricing";
import ExperienceDetail from "../../../Components/Host/Dashboard/ExperienceDetail";
import Itinerary from "../../../Components/Host/Dashboard/Itinerary";
import ScheduleLocation from "../../../Components/Host/Dashboard/ScheduleLocation";
import { fetchCmsMetaData } from "../../../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../../../Components/Utility/setMetaTags";

function ReservationListing() {
  const [activeTab, setActiveTab] = useState(0);
   const [experienceId, setExperienceId] = useState(null);
    const [completedTabs, setCompletedTabs] = useState([]);
    const location = useLocation();
    const isEdit = location.state?.isEdit;
    const [meta,setMeta] = useState();

  const markTabComplete = (index) => {
    setCompletedTabs((prev) =>
      prev.includes(index) ? prev : [...prev, index]
    );
    setActiveTab(index + 1); 
  };

  useEffect(() => {
  return () => {
   
    localStorage.removeItem("experience_id");
  };
}, []);


  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [activeTab]); // ✅ scrolls every time tab changes

  // ✅ Auto move to Package Detail tab in edit mode
useEffect(() => {
  if (isEdit) {
    setActiveTab(0); // open Package Detail tab
    setCompletedTabs([0, 1, 2, 3]); // allow free navigation
  }
}, [isEdit]);


   // ✅ Allow free tab movement in edit mode
  const handleTabSelect = (index) => {
    
    if (isEdit) {
      setActiveTab(index);
      return true;
    }

    // Prevent clicking future tabs in create mode
    if (index === activeTab) return true;
    if (completedTabs.includes(index - 1) || completedTabs.includes(index)) {
      setActiveTab(index);
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("resevation");
      setMeta(data);
    };

    loadMeta();
  }, []);

  return (
    <section className="ser_v_araeea ntx_tabs_links al_bootm_spance">

       <SetMetaTags
        title= {meta?.meta_title || "Resevation| Weyfarin"}
        description={meta?.meta_description || "Resevation| Weyfarin"}
      
      />

      <div className="container">
        <Tabs
        //  selectedIndex={activeTab} onSelect={(index) => setActiveTab(index)}
        // selectedIndex={activeTab} onSelect={(index) => setActiveTab(index)}
        selectedIndex={activeTab} onSelect={handleTabSelect}
         >
          {/* ✅ Tab Headers */}
          <TabList>
            <Tab  className={`react-tabs__tab 
    ${activeTab === 0 ? "react-tabs__tab--selected" : ""} 
    ${completedTabs.includes(0) ? "react-tabs__tab--selected" : ""}`}>
              <h5>Experience Details</h5>
              <span className="tikkks"></span>
            </Tab>
            <Tab  className={`react-tabs__tab 
            
    ${activeTab === 1 ? "react-tabs__tab--selected" : ""} 
    ${completedTabs.includes(1) ? "react-tabs__tab--selected" : ""}`} 
    disabled={!completedTabs.includes(0)}>
              <h5>Package Detail</h5>
              <span className="tikkks"></span>
            </Tab>
            <Tab  className={`react-tabs__tab 
    ${activeTab === 2 ? "react-tabs__tab--selected" : ""} 
    ${completedTabs.includes(2) ? "react-tabs__tab--selected" : ""}`} 
    disabled={!completedTabs.includes(1)}>
              <h5>Itinerary </h5>
              <span className="tikkks"></span>
            </Tab>
            <Tab  className={`react-tabs__tab 
    ${activeTab === 3 ? "react-tabs__tab--selected" : ""} 
    ${completedTabs.includes(3) ? "react-tabs__tab--selected" : ""}`}
    disabled={!completedTabs.includes(2)} >
              <h5>Schedule</h5>
              <span className="tikkks"></span>
            </Tab>
          </TabList>

          {/* ✅ Tab Panels */}
          <TabPanel>
            <ExperienceDetail  onSuccess={(id) => {
              markTabComplete(0)
            setExperienceId(id);     // ✅ store returned id
            // setActiveTab(1);         // go to itinerary
          }} />
          </TabPanel>

          <TabPanel>
            <Itinerary experienceId={experienceId} onSuccess={() => markTabComplete(1)} onBack={() => setActiveTab(0)} />
          </TabPanel>

          <TabPanel>
            <CapacityPricing experienceId={experienceId} onSuccess={() => markTabComplete(2)} onBack={() => setActiveTab(1)} />
          </TabPanel>

          <TabPanel>
            <ScheduleLocation
            experienceId={experienceId}
              onSuccess={() => {
                markTabComplete(3)
              }}

              onBack={() => setActiveTab(2)}
            />
          </TabPanel>
        </Tabs>
      </div>
    </section>
  );
}

export default ReservationListing;
